import { render, staticRenderFns } from "./deleteMenuItemConfirmation.vue?vue&type=template&id=673012d2&"
import script from "./deleteMenuItemConfirmation.vue?vue&type=script&lang=ts&"
export * from "./deleteMenuItemConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports